import 'vendor/modernizr'

angular
  .module 'memberPortal'
  .directive 'nativeDatepicker', (
    $state,
  ) ->
    restrict: 'E'
    template: require('templates/member_portal/native_datepicker.html.slim')
    scope:
      model: '='
      minDate: '='
      maxDate: '='
      displayFormat: '@'
      name: '@'
      elementId: '@'
      onChange: '&'
    controller: ($scope) ->
      $scope.dateInputSupported = window.Modernizr.inputtypes.date
      $scope.displayFormat = $scope.displayFormat || 'dd MMM yyyy'

      $scope.onDateChange = (value) ->
        $scope.onChange(value: value)

      $scope.printDay = (date) ->
        moment(new Date(date)).format($scope.displayFormat)
